import { render, staticRenderFns } from "./onebox-packagecitizen-new.vue?vue&type=template&id=44f446e4&scoped=true&"
import script from "./onebox-packagecitizen-new.vue?vue&type=script&lang=js&"
export * from "./onebox-packagecitizen-new.vue?vue&type=script&lang=js&"
import style0 from "./onebox-packagecitizen-new.vue?vue&type=style&index=0&id=44f446e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f446e4",
  null
  
)

export default component.exports